module.exports = __webpack_public_path__ + "img/default_h.daa64dce.png";